import type { EntityConfig } from '../types'

export const subscriptionEntity: EntityConfig = {
  id: 'subscription',
  displayName: 'Subscription',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'scheduled', label: 'Scheduled' },
      { value: 'cancelled', label: 'Cancelled' }
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'inactive', label: 'Inactive', color: 'error' },
      { value: 'scheduled', label: 'Scheduled', color: 'pending' },
      { value: 'cancelled', label: 'Cancelled', color: 'neutral' }
    ],
    mappings: {
      all: ['active', 'inactive', 'scheduled', 'cancelled'],
      active: ['active'],
      inactive: ['inactive'],
      scheduled: ['scheduled'],
      cancelled: ['cancelled']
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    createdDate: { type: 'date_range', urlKey: 'createdDate' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'status',
    'customers',
    'createdDate',
  ]
}
